import { generateTracker } from '@/core/monitoring/trackEvents';

type MediaDisplayInfo = {
  media_type: 'video' | 'image';
  from_id: 'share' | 'result';
  has_watermark: boolean;
};

const mediaDisplayTracker = generateTracker<MediaDisplayInfo>([
  'output',
  'media',
  'display',
]);

export default mediaDisplayTracker;
